import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_6: FaireProductEntity = {
  token: "nyc-bev-6",
  type: "product",
  name: "Artisan Lemonade",
  brandName: "Fresh Press Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e91bd133da97249615f4e7b28d4749bdb811474cb26606fcdacc5e617f253e7.webp",
  priceDollars: 5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e91bd133da97249615f4e7b28d4749bdb811474cb26606fcdacc5e617f253e7.webp",
  weight: 1.2,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description: "Small-batch craft soda from the Bronx",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "artisanal"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
